<template>
  <div>
    <el-row class="heigh-contenedor2 hidden-sm-and-down">
      <el-col :md="14" :sm="24" :xs="24" class="padding-box" style="display: flex !important; align-items: center !important">
        <div class="contenedor-flex card-sumate">
          <p class="msj_cultura texto-sumate" v-html="$t('sumate.mensaje')"></p>
        </div>
        <!-- <div class="hidden-xs-only texto-left">
          <p class="msj_cultura texto-sumate">{{ $t('comercial.title_1') }} <span style="color: #d35915" v-html="$t('comercial.title_2')"></span></p>
        </div> -->
      </el-col>

      <el-col :md="10" :sm="24" :xs="24" class="columna2 heigh-contenedor" style="display: flex !important; align-items: center !important">
        <div style="/* o la medida que estés usando */ position: relative">
          <el-button class="title2" style="transform: translate(-14%, 0%)" type="warning" @click="showForm" v-html="$t('sumate.boton')"></el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="hidden-md-and-up">
      <el-col :md="14" :sm="24" :xs="24" class="padding-comercial-cel" style="display: flex !important; align-items: center !important">
        <div class="contenedor-flex card-sumate">
          <p class="msj_cultura texto-sumate" v-html="$t('sumate.mensaje_mobile')"></p>
        </div>
      </el-col>
      <el-col :md="10" :sm="24" :xs="24" class="columna2 heigh-contenedor" style="display: grid !important; align-items: center !important">
        <el-button style="width: 100%" class="title2" type="warning" @click="showForm" v-html="$t('sumate.boton')"></el-button>
      </el-col>
    </el-row>

    <div class="bg-nosotros-2" style="background-color: #ececee" v-if="centerDialogVisible">
      <el-row
        ><el-col>
          <h2 style="color: #d35915" class="hidden-xs-only hidden-sm-and-down">
            <center>{{ $t('sumate.title_formulario') }}</center>
          </h2>
          <h3 style="color: #d35915" class="hidden-md-and-up">
            <center>{{ $t('sumate.title_formulario') }}</center>
          </h3>
          <el-form label-position="top" :model="formPostulacion" ref="formPostulacion" :rules="rules">
            <el-row :gutter="20">
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item size="small" :label="$t('sumate.campos_form[0]')" prop="nombre">
                  <el-input v-model="formPostulacion.nombre" :placeholder="$t('sumate.placeholder[0]')" clearable :disabled="enviando"></el-input> </el-form-item
              ></el-col>
              <el-col :md="8" :sm="12">
                <el-form-item size="small" :label="$t('sumate.campos_form[1]')" prop="apellido">
                  <el-input v-model="formPostulacion.apellido" :placeholder="$t('sumate.placeholder[1]')" clearable :disabled="enviando"></el-input> </el-form-item
              ></el-col>
              <el-col :md="4" :sm="12">
                <el-form-item size="small" :label="$t('sumate.campos_form[2]')" prop="dni">
                  <el-input
                    v-validate="'numeric'"
                    data-vv-as="field"
                    v-model.number="formPostulacion.dni"
                    autocomplete="off"
                    :placeholder="$t('sumate.placeholder[2]')"
                    clearable
                    max="10"
                    :disabled="enviando"></el-input> </el-form-item
              ></el-col>
              <el-col :md="4" :sm="12">
                <el-form-item size="small" :label="$t('sumate.campos_form[3]')" prop="fecha">
                  <el-date-picker
                    v-model="formPostulacion.fecha"
                    value-format="yyyy-MM-dd"
                    format="dd-MM-yyyy"
                    type="date"
                    :placeholder="$t('sumate.placeholder[3]')"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                    clearable
                    :disabled="true">
                  </el-date-picker> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :md="8">
                <el-form-item size="small" :label="$t('sumate.campos_form[4]')" prop="areas">
                  <el-select v-model="formPostulacion.areas" :placeholder="$t('sumate.placeholder[4]')" filterable clearable style="width: 100%" multiple collapse-tags :disabled="enviando">
                    <el-option v-for="item in areas" :key="item" :label="item" :value="item">{{ item }} </el-option>
                  </el-select>
                </el-form-item></el-col
              >
              <el-col :md="6">
                <el-form-item size="small" :label="$t('sumate.campos_form[5]')" prop="formacion">
                  <el-select v-model="formPostulacion.formacion" :placeholder="$t('sumate.placeholder[5]')" style="width: 100%" clearable filterable :disabled="enviando">
                    <el-option v-for="form in formaciones" :key="form" :label="form" :value="form" mu> </el-option>
                  </el-select> </el-form-item
              ></el-col>
              <el-col :md="6">
                <el-form-item size="small" :label="$t('sumate.campos_form[6]')" prop="residencia">
                  <el-select v-model="formPostulacion.residencia" :placeholder="$t('sumate.placeholder[6]')" style="width: 100%" clearable filterable :disabled="enviando">
                    <el-option v-for="res in residencias" :key="res" :label="res" :value="res"> {{ res }}</el-option>
                  </el-select>
                </el-form-item></el-col
              >
              <el-col :md="4">
                <el-form-item size="small" :label="$t('sumate.campos_form[7]')" prop="cv">
                  <el-upload
                    class="upload-demo"
                    action="#"
                    :on-preview="handlePreview"
                    :before-upload="beforeUpload"
                    :limit="1"
                    :file-list="fileList"
                    :on-change="handleChange"
                    :on-exceed="handleExceed"
                    :auto-upload="false"
                    :on-remove="handleRemove"
                    ref="uploadCv"
                    :disabled="enviando">
                    <el-button size="small" type="primary">Clic para subir archivo</el-button>
                    <div slot="tip" class="el-upload__tip">Solo archivos PDF</div>
                  </el-upload>
                </el-form-item></el-col
              >
            </el-row>
            <!-- <el-button type="primary" @click="submitUpload"> Subir archivo </el-button> -->
            <el-row :gutter="20" style="padding: 0px 20px"
              ><el-col>
                <el-form-item style="text-align: center">
                  <el-button type="warning" style="background-color: #d35915" @click="submitForm('formPostulacion')" icon="el-icon-thumb" :loading="enviando">{{
                    $t('sumate.campos_form[8]')
                  }}</el-button>
                  <el-button type="default" @click="limpiarForm()" icon="el-icon-close" :disabled="enviando">{{ $t('sumate.campos_form[9]') }}</el-button>
                </el-form-item></el-col
              >
            </el-row>
          </el-form></el-col
        ></el-row
      >
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { HTTP } from '@/axios.js'
import { EventBus } from '@/event-bus.js'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Swal from 'sweetalert2'
import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)
export default {
  data() {
    var validarDNI = (rule, value, callback) => {
      console.log(Number.isInteger(value))
      if (!value) {
        return callback(new Error('Por favor, ingrese su DNI'))
      }
      if (!Number.isInteger(value)) {
        callback(new Error('Por favor, ingrese sólo números'))
      } else {
        if (value.toString().length > 9) {
          callback(new Error('Por favor, ingrese un dni correcto'))
        } else {
          callback()
        }
      }
    }
    return {
      images: require('@/assets/fotos/CV.jpg'),
      centerDialogVisible: false,
      formPostulacion: {
        nombre: null,
        apellido: null,
        dni: null,
        fecha: new Date(),
        areas: null,
        residencia: null,
        formacion: null,
        cv: null,
      },
      fileList: [],

      pickerOptions: {
        disabledDate(date) {
          return date.getTime() <= moment().subtract(1, 'days')
        },
      },
      rules: {
        nombre: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        apellido: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        dni: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          { validator: validarDNI, trigger: ['blur', 'change'] },
        ],
        fecha: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        areas: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        residencia: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        formacion: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        cv: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('Debe adjuntar su CV'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      },
      residencias: [
        'Capital Federal',
        'Buenos Aires',
        'Buenos Aires GBA Norte',
        'Buenos Aires GBA Oeste',
        'Buenos Aires GBA Sur',
        'Catamarca',
        'Córdoba',
        'Corrientes',
        'Chaco',
        'Chubut',
        'Entre Ríos',
        'Formosa',
        'Jujuy',
        'La Pampa',
        'La Rioja',
        'Mendoza',
        'Misiones',
        'Neuquén',
        'Río Negro',
        'Salta',
        'San Juan',
        'San Luis',
        'Santa Cruz',
        'Santa Fe',
        'Santiago del Estero',
        'Tierra del Fuego',
        'Tucumán',
      ],
      formaciones: [
        'Secundario incompleto',
        'Secundario completo',
        'Terciario incompleto',
        'Terciario completo',
        'Universitario incompleto',
        'Universitario completo',
        'Posgrado / Master / Doctorado',
      ],
      areas: [
        'Administración / Oficina ',
        ' Almacén / Logística / Transporte / Operarios / Choferes ',
        'Atención a clientes',
        'Comercial / Ventas',
        'Contact center',
        'Compras / Comercio exterior ',
        'Contabilidad / Finanzas',
        'Dirección / Gerencia',
        'Diseño / Artes gráficas',
        'Informática / Telecomunicaciones / Sistemas',
        'Ingeniería / Proyectos / Procesos / Mejora continua',
        'Calidad, Investigación, Farmacia y Asuntos Regulatorios',
        'Legales',
        'Mantenimiento y Reparaciones Técnicas',
        'Marketing / Publicidad / Comunicación',
        'Recursos Humanos ',
        'Servicios Generales ,Limpieza y Seguridad',
      ],
      formacionesES: [
        'Secundario incompleto',
        'Secundario completo',
        'Terciario incompleto',
        'Terciario completo',
        'Universitario incompleto',
        'Universitario completo',
        'Posgrado / Master / Doctorado',
      ],
      formacionesEN: [
        'Incomplete secondary education',
        'Complete secondary education',
        'Incomplete tertiary education',
        'Complete tertiary',
        'Incomplete university degree',
        'Complete University',
        'Postgraduate / Master / Doctorate',
      ],
      areasES: [
        'Administración / Oficina ',
        ' Almacén / Logística / Transporte / Operarios / Choferes ',
        'Atención a clientes',
        'Comercial / Ventas',
        'Contact center',
        'Compras / Comercio exterior ',
        'Contabilidad / Finanzas',
        'Dirección / Gerencia',
        'Diseño / Artes gráficas',
        'Informática / Telecomunicaciones / Sistemas',
        'Ingeniería / Proyectos / Procesos / Mejora continua',
        'Calidad, Investigación, Farmacia y Asuntos Regulatorios',
        'Legales',
        'Mantenimiento y Reparaciones Técnicas',
        'Marketing / Publicidad / Comunicación',
        'Recursos Humanos ',
        'Servicios Generales ,Limpieza y Seguridad',
      ],
      areasEN: [
        'Administration / Office ',
        'Store / Logistics / Transport / Operators / Drivers ',
        'Customer service',
        'Commercial / Sales',
        'Contact center',
        'Shopping / Foreign trade',
        'Accounting / Finance',
        'Management',
        'Design / Graphic arts',
        'Computing / Telecommunications / Systems',
        'Engineering / Projects / Processes / Continuous improvement',
        'Quality, Investigation, Pharmacy y Regulatory Affairs',
        'Legal',
        'Maintenance and Technical Repairs',
        'Marketing / Advertising / Communication',
        'Human Resources',
        'General Services, Cleaning and Security',
      ],
      enviando: false,
    }
  },
  mounted() {
    AOS.init({
      duration: 1000,
      offset: 100,
      once: false, // false = animaciones se repiten al volver a scrollear
    })

    EventBus.$on('change-lenguaje', (lenguaje) => {
      if (lenguaje == 'es') {
        this.formaciones = [
          'Secundario incompleto',
          'Secundario completo',
          'Terciario incompleto',
          'Terciario completo',
          'Universitario incompleto',
          'Universitario completo',
          'Posgrado / Master / Doctorado',
        ]
        this.areas = [
          'Administración / Oficina ',
          ' Almacén / Logística / Transporte / Operarios / Choferes ',
          'Atención a clientes',
          'Comercial / Ventas',
          'Contact center',
          'Compras / Comercio exterior ',
          'Contabilidad / Finanzas',
          'Dirección / Gerencia',
          'Diseño / Artes gráficas',
          'Informática / Telecomunicaciones / Sistemas',
          'Ingeniería / Proyectos / Procesos / Mejora continua',
          'Calidad, Investigación, Farmacia y Asuntos Regulatorios',
          'Legales',
          'Mantenimiento y Reparaciones Técnicas',
          'Marketing / Publicidad / Comunicación',
          'Recursos Humanos ',
          'Servicios Generales ,Limpieza y Seguridad',
        ]
      } else {
        this.formaciones = this.formacionesEN
        this.areas = this.areasEN
      }
    })
    if (this.$i18n.locale == 'en') {
      this.formaciones = [
        'Incomplete secondary education',
        'Complete secondary education',
        'Incomplete tertiary education',
        'Complete tertiary',
        'Incomplete university degree',
        'Complete University',
        'Postgraduate / Master / Doctorate',
      ]
      this.areas = [
        'Administration / Office ',
        'Store / Logistics / Transport / Operators / Drivers ',
        'Customer service',
        'Commercial / Sales',
        'Contact center',
        'Shopping / Foreign trade',
        'Accounting / Finance',
        'Management',
        'Design / Graphic arts',
        'Computing / Telecommunications / Systems',
        'Engineering / Projects / Processes / Continuous improvement',
        'Quality, Investigation, Pharmacy y Regulatory Affairs',
        'Legal',
        'Maintenance and Technical Repairs',
        'Marketing / Advertising / Communication',
        'Human Resources',
        'General Services, Cleaning and Security',
      ]
    } else {
      this.formaciones = [
        'Secundario incompleto',
        'Secundario completo',
        'Terciario incompleto',
        'Terciario completo',
        'Universitario incompleto',
        'Universitario completo',
        'Posgrado / Master / Doctorado',
      ]
      this.areas = [
        'Administración / Oficina ',
        ' Almacén / Logística / Transporte / Operarios / Choferes ',
        'Atención a clientes',
        'Comercial / Ventas',
        'Contact center',
        'Compras / Comercio exterior ',
        'Contabilidad / Finanzas',
        'Dirección / Gerencia',
        'Diseño / Artes gráficas',
        'Informática / Telecomunicaciones / Sistemas',
        'Ingeniería / Proyectos / Procesos / Mejora continua',
        'Calidad, Investigación, Farmacia y Asuntos Regulatorios',
        'Legales',
        'Mantenimiento y Reparaciones Técnicas',
        'Marketing / Publicidad / Comunicación',
        'Recursos Humanos ',
        'Servicios Generales ,Limpieza y Seguridad',
      ]
    }
  },
  beforeDestroy() {
    EventBus.$off('change-lenguaje', false)
  },
  methods: {
    handleChange(file, fileList) {
      let estado = this.beforeUpload(file)
      // alert(estado)
      if (!estado) {
        this.$message({
          message: '¡Los archivos cargados solo pueden estar en formato .pdf!',
          type: 'warning',
        })
        this.no_corresponde = true
      } else {
        this.formPostulacion.cv = file.raw // 👈 clave
        this.fileList.push(file)
        this.$refs.formPostulacion.validateField('cv')
      }
      console.log(file, fileList)
    },
    eliminarElemento(file, fileList) {
      console.log(file, fileList)
      this.fileList = fileList
    },
    submitUpload() {
      this.$refs.uploadCv.submit()
    },
    showForm() {
      // alert('algo')
      this.centerDialogVisible = !this.centerDialogVisible
    },
    handleRemove() {
      this.formPostulacion.cv = null
      this.fileList = []
      this.$refs.formPostulacion.validateField('cv')
    },
    handlePreview(file) {
      // alert(file)
      console.log(file)
    },
    handleExceed(files) {
      this.$message.warning(`Sólo puede cargar ${files.length} archivo`)
    },
    beforeUpload(file) {
      const isPdf = file.raw.type === 'application/pdf'
      const isLt1M = file.raw.size / 1024 / 1024 < 1
      // console.log('file', file.raw.type)
      // console.log(isPdf)

      // console.log(isLt1M)

      if (!isPdf) {
        // alert('Avatar picture must be JPG format!');
        this.$message.error(this.$t('contacto.form.archivo_tipo'))
      }
      if (!isLt1M) {
        this.$message.error(this.$t('contacto.form.archivo_tipo'))
      }
      return isPdf && isLt1M
    },
    submitForm(formName) {
      // console.log(this.formPostulacion)
      // console.log(this.$refs[formName])
      this.enviando = true
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.enviando = false

          return
        } else {
          if (this.formPostulacion.cv !== null) {
            const formData = new FormData()
            formData.append('nombre', this.formPostulacion.nombre)
            formData.append('apellido', this.formPostulacion.apellido)
            formData.append('dni', this.formPostulacion.dni)
            formData.append('fecha', this.formPostulacion.fecha)
            formData.append('areas', this.formPostulacion.areas)
            formData.append('residencia', this.formPostulacion.residencia)
            formData.append('formacion', this.formPostulacion.formacion)
            formData.append('cv', this.formPostulacion.cv)

            // 👇 subida manual
            HTTP.post('/escanerPrueba/uploadPdfLoginPrueba', formData)
              .then((res) => {
                if (res.data) {
                  Swal.fire({
                    title: 'Formulario enviado!',
                    text: 'Gracias, pronto nos comunicaremos con usted.',
                    icon: 'success',
                    draggable: true,
                    // confirmButtonText: 'Cool',
                  })
                  this.centerDialogVisible = false
                } else {
                  this.$message.error('Oops, hubo un problema para enviar el pedido.')
                }
                this.enviando = false
              })
              .catch(() => {
                this.$message.error('Error al enviar CV')
                this.enviando = false
              })
          } else {
            this.$message.warning(`Debe cargar su Curriculum`)
          }
        }
      })
    },
  },
  uploadCurri(param) {
    console.log('parametros', param)

    const formdata = new FormData()
    formdata.append('upload', param.file)

    HTTP.post('/uploadExcel/uploadCV', formdata, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((res) => {
        console.log(res.data)
      })
      .catch((error) => {
        console.log(error)
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar el archivo',
        })
      })
  },
  enviarMailCv() {
    // let url = response.url
    // let cvMsj = 'Puede descargar el CV haciendo click: <a href="' + url + '" >' + url + '</a> '
    // HTTP.post(
    //   '/webLogin/enviarMail',
    //   null,
    //   {
    //     params: {
    //       tipo: this.tipo,
    //       nombre: this.form.nombre,
    //       correo: this.form.email,
    //       mensaje: cvMsj,
    //     },
    //   },
    //   { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    // ).then((res) => {
    //   console.log(res)
    //   this.form = {}
    //   this.tipo = 'enviado'
    //   this.procesando = false
    // })
  },
  limpiarForm() {
    this.centerDialogVisible = false
    alert(this.centerDialogVisible)
    this.formPostulacion.nombre = null
    this.formPostulacion.apellido = null
    this.formPostulacion.dni = null
    this.formPostulacion.fecha = new Date()
    this.formPostulacion.areas = null
    this.formPostulacion.residencia = null
    this.formPostulacion.formacion = null
    this.formPostulacion.cv = null
  },
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Sura:wght@400;700&display=swap');

:root {
  --src: url(https://images.unsplash.com/photo-1554620121-59e7f3f6e3a4?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy);
  /* --size: 35vmin; */
  /* --space: 100vmin; */
  --duration: 300ms;
  /* --ease-out: cubic-bezier(0.25, 1, 0.5, 1); */
  /* --bounce-out: cubic-bezier(0.34, 1.56, 0.64, 1); */
}
.css-click {
  margin: 0px;
  font-size: 23px;
  font-family: 'roboto-black';
}
.contenedor-flex2,
.contenedor-flex {
  display: flex;
  justify-content: flex-start;
  align-items: center !important;
  height: 40vh; /* Altura de ejemplo */
  /* padding: 0% 12% 0% 20%; */
  /* background-color: #f0f0f0; */
}

.card-sumate {
  display: grid;
  align-items: center;
  /* margin-top: 9%; */
}
.texto-sumate {
  /* padding: 0px 20%; */
  color: #706f6e;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'roboto-regular'; /* centra verticalmente el texto */
  margin: 0px;
  line-height: 1.5;
}
.contenedor-flex {
  height: 40vh;
}
.heigh-contenedor2 {
  height: 40vh;
}
.promo {
  position: relative;
  /* cursor: pointer; */
  /* width: var(--size); */
  /* height: var(--size); */
}

.title2 {
  --font-size: calc(var(--size) / 8);
  /* display: flex; */
  /* align-items: center; */
  /* position: absolute; */
  left: 0;
  bottom: 0;
  font-size: var(--font-size);
  line-height: 1.2;
  white-space: nowrap;
  /* transform: translate(-10%, -50%); */
  /* transition: transform var(--duration) var(--ease-out); */
  /* margin-bottom: 19%; */
  background-color: #d35915;
  border-color: #d35915;
  font-size: 20px;
  /* padding: 2% 6%; */
  font-family: 'MONTSERRAT-WHT';
  text-align: left;
}

.title2::after {
  content: attr(data-cta);
  display: inline-block;
  margin-left: 1.5vmin;
  font-size: calc(var(--font-size) / 3.25);
  font-weight: 400;
  letter-spacing: 0.125vmin;
  opacity: 0;
  transform: translateX(-25%);
  transition:
    transform var(--duration) var(--ease-out),
    opacity var(--duration) var(--ease-out);
}
.title2:hover {
  background-color: #d35915;
  border-color: #d35915;
}
.columna2 {
  background-image: url('~@/assets/fotos/CV.jpg') !important; /* ruta válida Vue 2 */
  background-size: cover; /* para que cubra toda la columna */
  background-position: center; /* centrar la imagen dentro */
  background-repeat: no-repeat;
}
/* .image-wrapper {
  width: var(--size);
  height: var(--size);
  overflow: hidden;
  clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 0 50%, 0% 0%);
  transition:
    transform var(--duration) var(--ease-out),
    clip-path var(--duration) var(--ease-out);
} */

/* .image-wrapper img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  float: inline-end;
} */

/* .image-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--overlay-color);
  mix-blend-mode: multiply;
  opacity: 0;
  transform: translateZ(0);
  transition: opacity var(--duration) var(--ease-out);
} */

/* .promo:hover img {
  transform: translateX(0);
}

.promo:hover .image-wrapper {
  clip-path: polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%);
  transform: translateX(25%);
  transition-timing-function: var(--bounce-out);
}

.promo:hover .title {
  transform: translate(5%, -50%);
  transition-timing-function: var(--bounce-out);
}

.promo:hover .title::after {
  opacity: 1;
  transform: translateX(0);
  transition-timing-function: var(--bounce-out);
}

.promo:hover .image-wrapper::after {
  opacity: 1;
} */

.contenedor-imagen {
  width: 100%; /* Ocupa todo el ancho de la columna */
  height: 100%; /* Ajusta el alto según necesites */
  overflow: hidden; /* Asegura que la imagen no se salga del contenedor */
}

.contenedor-imagen img {
  width: 100%;
  height: 80%;
  object-fit: cover; /* Llena el contenedor manteniendo la relación de aspecto */
}
.msj_cultura {
  text-align: left;
  /* hyphens: auto; */
}
@media (min-width: 2561px) {
  .msj_cultura {
    font-size: 27px;
  }
  .card-sumate {
    display: grid;
    align-items: center;
    /* margin-top: 15%; */
  }
  .title2 {
    font-size: 25px;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .msj_cultura {
    font-size: 26px;
    /* margin-bottom: 2.5%; */
  }
  .card-sumate {
    display: grid;
    align-items: center;
    /* margin-top: 20%; */
  }
  .title2 {
    font-size: 25px;
    /* margin-bottom: 12%; */
  }
  .contenedor-flex {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40vh; /* Altura de ejemplo */
    /* padding: 0% 12% 0% 16%; */
    /* background-color: #f0f0f0; */
  }
  .contenedor-flex2 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 39vh; /* Altura de ejemplo */
    padding: 0% 20% 0% 16%;
    /* background-color: #f0f0f0; */
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .msj_cultura {
    font-size: 24px;
    /* margin-bottom: 2.5%; */
  }
  .card-sumate {
    display: grid;
    align-items: center;
    /* margin-top: 17%; */
  }
  .title2 {
    font-size: 23px;
    /* margin-bottom: 15%; */
    /* margin-bottom: 15%; */
  }
  .texto-sumate {
    /* padding: 0px 21%; */
    color: #706f6e;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: 'roboto-regular'; /* centra verticalmente el texto */
    margin: 0px;
    line-height: 1.5;
  }
  .contenedor-flex,
  .contenedor-flex2 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40vh; /* Altura de ejemplo */
    /* padding: 0% 12% 0% 16%; */
    /* background-color: #f0f0f0; */
  }
  .contenedor-flex2 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 39vh; /* Altura de ejemplo */
    padding: 0% 22% 0% 16%;
    text-align: left;
    /* background-color: #f0f0f0; */
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .msj_cultura {
    font-size: 21px;
    /* margin-bottom: 2.5%; */
  }
  .card-sumate {
    display: grid;
    align-items: center;
    margin-top: 0%;
  }
  .title2 {
    font-size: 20px;
    /* margin-bottom: 21% !important; */
  }
  .texto-sumate {
    /* padding: 0px 13% 0px 21%; */
    color: #706f6e;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: 'roboto-regular'; /* centra verticalmente el texto */
    margin: 0px;
    line-height: 1.3;
  }
}
@media screen and (min-width: 720px) and (max-width: 1280px) {
  .msj_cultura {
    font-size: 21px;
    /* margin-bottom: 2.5%; */
    hyphens: none;
  }

  .card-sumate {
    display: grid;
    align-items: center;
    margin-top: 0%;
  }
  .title2 {
    font-size: 20px;
    /* margin-bottom: 21% !important; */
  }
  .texto-sumate {
    /* padding: 0px 13% 0px 21%; */
    color: #706f6e;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: 'roboto-regular'; /* centra verticalmente el texto */
    margin: 0px;
    line-height: 1.3;
  }
  .contenedor-flex,
  .heigh-contenedor,
  .promo .image-wrapper {
    height: 20vh;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .msj_cultura {
    font-size: 19px;
    /* margin-bottom: 12%; */
  }
  .card-sumate {
    display: grid;
    align-items: center;
    margin-top: 0%;
    /* height: 350px; */
  }
  .title2 {
    font-size: 19px;
    /* left: 250px; */
    /* margin-bottom: 10%; */
    /* left: 0px; */
  }
}
@media (orientation: landscape) and (max-height: 500px) {
  .heigh-contenedor,
  .promo .image-wrapper,
  .heigh-contenedor2,
  .contenedor-flex,
  .contenedor-flex2 {
    height: 60vh !important;
  }
  .padding-comercial-cel {
    padding: 0% 10%;
  }
}
@media (orientation: portrait) {
  .padding-comercial-cel {
    padding: 5% 10%;
  }
}

@media screen and (min-width: 375px) and (max-width: 767px) {
  .heigh-contenedor,
  .promo .image-wrapper,
  .heigh-contenedor2,
  .contenedor-flex,
  .contenedor-flex2 {
    height: 30vh;
  }
  .msj_cultura {
    font-size: 18px;
    line-height: 1.4;
    /* hyphens: auto; */

    /* margin-bottom: 12%; */
  }
  .card-sumate {
    display: grid;
    align-items: center;
    margin-top: 0%;
    /* height: 250px; */
  }
  .title2 {
    font-size: 12px;
    /* padding: 2% 7%;
    margin-bottom: 0%;
    bottom: 30%;
    left: -5%; */
  }
  .texto-sumate {
    padding: 0px;
    color: #706f6e;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: 'roboto-regular'; /* centra verticalmente el texto */
    margin: 0px;
    text-align: left;
    hyphens: auto;
  }
  .css-click {
    font-size: 19px;
  }
  /* .contenedor-flex,
  .contenedor-flex2 {
    height: 20vh;
  } */
}
@media (max-width: 375px) {
  .heigh-contenedor,
  .promo .image-wrapper,
  .heigh-contenedor2,
  .contenedor-flex,
  .contenedor-flex2 {
    height: 30vh;
  }
  .msj_cultura {
    font-size: 18px;
    line-height: 1.4;
    /* margin-bottom: 12%; */
    /* hyphens: auto; */
  }
  .card-sumate {
    display: grid;
    align-items: center;
    margin-top: 0%;
    /* height: 250px; */
  }
  .title2 {
    font-size: 12px;
    /* padding: 2% 7%;
    margin-bottom: 0%;
    bottom: 30%;
    left: -5%; */
    /* top: -5%; */
  }
  .texto-sumate {
    padding: 0px;
    color: #706f6e;
    display: flex;
    /* flex-direction: column; */
    /* justify-content: center; */
    font-family: 'roboto-regular'; /* centra verticalmente el texto */
    /* margin: 0px; */
    text-align: left;
    hyphens: auto;
  }
  .css-click {
    font-size: 19px;
  }
  /* .contenedor-flex,
  .contenedor-flex2 {
    height: 20vh;
  } */
}
</style>
<style scoped>
.el-button {
  border-radius: 0px;
}
</style>
